module.exports = __webpack_public_path__ + "static/tcs-poster-e50a955277ed57d4934512a605a576e7.png";